import { __assign, __extends } from "tslib";
import BaseRepository from '@/core/standard/BaseRepository';
import { axiosInstance } from '@/setup/axios/AxiosConfig';

var PaymentsService =
/** @class */
function (_super) {
  __extends(PaymentsService, _super);

  function PaymentsService() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.version = 'v1';
    _this.collection = 'payments';
    return _this;
  }

  PaymentsService.prototype.makeSplitPaymentByPrice = function (params) {
    return this.request(params);
  };

  PaymentsService.prototype.makeSplitPaymentByProducts = function (params) {
    return this.request(params);
  };

  PaymentsService.prototype.restorePayments = function (params) {
    return this.request(params);
  };

  PaymentsService.prototype.restoreItem = function (params) {
    return this.request(params);
  };

  PaymentsService.prototype.getPaymentsType = function (params) {
    return this.request(params);
  };

  PaymentsService.prototype.check = function (params) {
    return this.request(params);
  };

  PaymentsService.prototype.insertEconomicSubscription = function (params) {
    return this.request(__assign(__assign({}, params), {
      url: 'economic_subscriptions',
      method: 'POST'
    }));
  };

  PaymentsService.prototype.insertExpenseReport = function (params) {
    return this.request(__assign(__assign({}, params), {
      url: 'expenses',
      method: 'POST'
    }));
  };

  PaymentsService.prototype.closeWithDojo = function (params) {
    return this.request(__assign(__assign({}, params), {
      url: 'dojo',
      method: 'POST'
    }));
  };

  PaymentsService.prototype.cancelCloseWithDojo = function (params) {
    return this.request(__assign(__assign({}, params), {
      url: 'dojo/cancel',
      method: 'POST'
    }));
  };

  PaymentsService.prototype.confirmHandSign = function (params) {
    return this.request(__assign(__assign({}, params), {
      url: 'dojo/transaction',
      method: 'POST'
    }));
  };

  PaymentsService.prototype.confirmPayment = function (params) {
    return this.request(__assign(__assign({}, params), {
      url: 'dojo/confirmation',
      method: 'POST'
    }));
  };

  PaymentsService.prototype.updateExpenseReport = function (params) {
    var id = params.query.id;
    delete params.query.id;
    return this.update(__assign(__assign({}, params), {
      url: "expenses/" + id
    }));
  };

  PaymentsService.prototype.deleteExpenseReport = function (params) {
    return this.deleteBy(__assign(__assign({}, params), {
      url: "expenses/" + params
    }));
  };

  PaymentsService.prototype.closeWithCashmatic = function (params) {
    return this.request(__assign(__assign({}, params), {
      url: 'cashmatic',
      method: 'POST'
    }));
  };

  PaymentsService.prototype.cancelCloseWithCashmatic = function (params) {
    return this.request(__assign(__assign({}, params), {
      url: 'cashmatic/cancel',
      method: 'POST'
    }));
  };

  return PaymentsService;
}(BaseRepository);

export default new PaymentsService(axiosInstance);